module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO ORIGINAL GOOGLE-af9987618b6cd4b8f86a7f9758929859.png";